<template>
  <a class="cm-documentation__content-link" :href="data.content.url">
    {{ data.content.text }}
  </a>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.cm-documentation__content-link {
  color: $color_green-new;

  &:hover {
    color: $color_green_darken;
  }
}
</style>
